export const model = {
    id: null,
    visiting_date: '',
    visiting_time: '',
    created_at: '',
    updated_at: '',
};
